/**
 *
 * @module pad
 *
 */

/* global module */

(function(root, factory) {

    if (typeof define === 'function' && define.amd) {
        define([], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.bamPad = factory();
    }

}(this, function() {

    'use strict';

    return function pad(string, desiredLength, padCharacter) {

        string = string.toString();
        padCharacter = padCharacter || '0';
        desiredLength = desiredLength || 2;

        while (string.length < desiredLength) {
            string = padCharacter + string;
        }

        return string;
    };

}));
